import React from 'react';
import PropTypes from 'prop-types';
import { Box, FormLabel, withStyles, FormHelperText } from '@material-ui/core';

const propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  label: PropTypes.node,
  title: PropTypes.node,
};
const defaultProps = {
  error: undefined,
  helperText: undefined,
  label: undefined,
  title: undefined,
};

const styles = theme => ({
  container: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top', // Fix alignment issue on Safari.
  },
  label: {
    marginBottom: theme.spacing(2),
  },
  title: {
    color: '#9c27b0 !important',
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    '& .MuiTextField-root': {
      flex: 1,
    },
  },
});

function InputGroup({ children, classes, error, label, helperText, title }) {
  return (
    <Box component={label ? 'fieldset' : undefined} className={classes.container}>
      {(title || label) && (
        <Box display="flex" alignItems="center" gap={1}>
          {title && (
            <Box mr={1}>
              <FormLabel component="legend" className={classes.title} error={error}>
                {title}
              </FormLabel>
            </Box>
          )}
          {label && (
            <FormLabel component="legend" className={classes.label} error={error}>
              {label}
            </FormLabel>
          )}
        </Box>
      )}
      <Box className={classes.inputContainer}>{children}</Box>

      {helperText ? <FormHelperText error={error}>{helperText}</FormHelperText> : null}
    </Box>
  );
}

InputGroup.propTypes = propTypes;
InputGroup.defaultProps = defaultProps;

export default withStyles(styles)(InputGroup);
